import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import CustomIcon from "../../../components/CustomIcon";
import {setPagesAddingOrEditing, setSelectedPage, tryGetDynamicUiPages} from "../../../redux/slices/dynamicUiSlice";
import {ComponentError} from "../../../components/ComponentLoader";
import DynamicUIPageAddModal from "./DynamicUIPageAddModal";
import DynamicUIPageDeleteModal from "./DynamicUIPageDeleteModal";
import {CustomTabRef} from "../../../components/tab/CustomTab";
import DropdownMenu, {DropdownItem, DropdownItemGroup} from "@atlaskit/dropdown-menu";
import CustomButton, {SecondaryButton} from "../../../components/CustomButton";
import DynamicPageGroupSelector from "../DynamicPageGroupSelector";
import PageTabModal from './tabs/PageTabModal'

const PageTabs = ({noItemsInTab = 3}) => {

  const selectedGroup = useSelector((state) => (state.dynamicUi.pages.selectedGroup));
  const {data, loading, init, error} = useSelector((state) => (state.dynamicUi.pages[selectedGroup]));
  const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage));
  const dispatch = useDispatch();
  const _data = Object.values(data);


  const [tabItems, setTabItems] = useState(_data.slice(0, noItemsInTab));
  const [dropDownItems, setDropDownItems] = useState(_data.slice(noItemsInTab, _data.length));

  useEffect(
    () => {
      if (!init && !error && !loading) {
        dispatch(tryGetDynamicUiPages());
      }

    },
    [init, loading, error]
  );


  useEffect(
    () => {

      if (!init) return;


      let _tabItems = _data.slice(0, noItemsInTab);
      let _dropItems = _data.slice(noItemsInTab, _data.length);
      if (_dropItems.length && !_tabItems.some((t) => t.id === selectedPage)) {
        const _tab = _data.find((d) => d.id === selectedPage);
        const removedItem = _tabItems[_tabItems.length - 1];

        _tabItems = [..._tabItems.slice(0, _tabItems.length - 1), _tab];
        _dropItems = _dropItems.map((item) => item.id === _tab.id ? removedItem : item);
      }

      setTabItems(_tabItems);
      setDropDownItems(_dropItems);


    },
    [data]
  );


  const hasNoData = init && !_data.length;

  const onSelect = (tab, fromDropDown = false) => {
    if (tab.id !== selectedPage) {
      dispatch(setSelectedPage({page: tab.id}));

      if (fromDropDown) {
        const removedItem = tabItems[tabItems.length - 1];

        setTabItems([...tabItems.slice(0, tabItems.length - 1), tab]);
        setDropDownItems(dropDownItems.map((item) => item.title === tab.title ? removedItem : item));
      }
    }

  };


  return (
    <>
      <div className="mb-4">
        {error ? <ComponentError errorMsg={error} retry={() => dispatch(tryGetDynamicUiPages())}/> :

          // hasNoData ? <ComponentNoData/> :
          <div className="bg-rand-100 rounded-md p-2 shadow-lg flex items-center space-x-2">
            {init &&
              <CustomButton isIconButton={true}
                            onClick={() => dispatch(setPagesAddingOrEditing({adding: true}))} title="Add A New Page">
                <CustomIcon icon="add"/>
              </CustomButton>
            }

            {/*{hasNoData && <PageTab disabled={true} className="w-[170px] h-9 " title="No pages in this group."/>}*/}

            {hasNoData ? <PageTab disabled={true} className="w-[170px] h-9 "
                                  title="No pages in this group."/> : (!init || loading) ?
              <>
                <SecondaryButton isIconButton={true}
                                 className="pointer-events-none bg-white/10 border-2 border-white/20">
                  <CustomIcon icon="add" className="text-rand-200"/>
                </SecondaryButton>
                <PageTab disabled={true} className="w-[106px] h-9"/>
                <PageTab disabled={true} className="w-[106px] h-9"/>
                <PageTab disabled={true} className="w-[106px] h-9"/>
                <PageTab disabled={true} className="w-[106px] h-9"/>
              </> :
              tabItems.map((tab, i) =>
                <PageTab key={`page${tab.id}`} onClick={() => onSelect(tab)} isSelected={tab.id === selectedPage}
                         title={tab.title} disabled={loading} toolTip={tab.title}/>
              )
            }

            {!!dropDownItems.length &&
              <DropdownMenu placement="bottom-end" shouldFlip isLoading={loading}
                            trigger={({triggerRef, isSelected, testId, ...props}) => (
                              <CustomTabRef ref={triggerRef} {...props} active={isSelected}
                                            className="bg-white/10 hover:bg-white/20 rounded-md px-3 py-1">
                                <CustomIcon icon="more_horiz" size="xl"
                                            className="cursor-pointer leading-7 text-white"/>
                              </CustomTabRef>
                            )}
              >
                <DropdownItemGroup>
                  {
                    dropDownItems.map((item, i) =>
                      <DropdownItem key={`${item.id}`}
                                    onClick={() =>
                                      onSelect(item, true)}
                      >
                        {item.title}
                      </DropdownItem>)
                  }

                </DropdownItemGroup>
              </DropdownMenu>
            }


            <DynamicPageGroupSelector/>
          </div>
        }


      </div>
      <DynamicUIPageAddModal/>
      <DynamicUIPageDeleteModal/>
      <PageTabModal/>
    </>
  );
};

const PageTab = ({title, disabled, isSelected, onClick, className, toolTip}) => {

  return (
    <div
      className={`${className ? ` ${className}` : ""} bg-white/10 rounded-md truncate transition${disabled ? " text-rand-200 cursor-not-allowed" : isSelected ? " text-secondary-500 cursor-defalut" : " text-white cursor-pointer hover:bg-white/20"} text-sm font-medium px-3 py-2`}
      onClick={onClick} title={toolTip}>
      {title}
    </div>
  );
};

export default React.memo(PageTabs);
